VjsAdmin.UserGroupsOwns = (function () {
    const me = {};
    me.$usergroups_table = $('#usergroups-table');
    me.platform_id = me.$usergroups_table.attr('data-platform-id');
    me.license_id = me.$usergroups_table.attr('data-license-id');
    me.user_id = me.$usergroups_table.attr('data-user-id');
    me.district_joint_guid = me.$usergroups_table.attr('data-district-joint-guid');

    me.init = function () {
        me.initTable();
    };

    me.initTable = function () {
        me.$usergroups_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#loginhistory-table',
            formatNoMatches() {
                return 'No groups for this User';
            },
            showColumns: true,
            buttonsAlign: 'right',
            idField: 'group_id',
            toolbar: '#report-toolbar',
            sortName: 'name',
            clickToSelect: true,
            url: Slim.Router.pathFor('platforms.districts.licenses.users.groups.owns.list.json', {
                platform_id: me.platform_id,
                license_id: me.license_id,
                user_id: me.user_id,
                district_joint_guid: me.district_joint_guid,
            }),
            columns: [
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Shared?',
                    field: 'shared',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Bulk Uploaded?',
                    field: 'bulk_upload_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '# Members',
                    field: 'number_of_users',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    field: 'student_count',
                    title: '# Students',
                    sortable: true,
                    align: 'left',
                    valign: 'middle',
                },
                {
                    field: 'staff_count',
                    title: '# Staff',
                    sortable: true,
                    align: 'left',
                    valign: 'middle',
                    visible: false,
                },
                {
                    field: 'admin_count',
                    title: '# Admins',
                    sortable: true,
                    align: 'left',
                    valign: 'middle',
                    visible: false,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'right',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the groups timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    if (+row.shared === 1) {
                        row.shared = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.shared = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }
                    if (row.bulk_upload_id >= 1) {
                        row.bulk_upload_id = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.bulk_upload_id = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }
                    if (VjsAdmin.hasPermission('platforms.districts.groups.view')) {
                        const groupUrl = Slim.Router.pathFor('platforms.districts.groups.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            group_id: row.group_id,
                        });
                        row.name = `<a href="${groupUrl}">${row.name}</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init: me.init,
    };
}());
